export const schedules = {
  resource: 'schedules',
  header: 'Manage Schedules',
  createNew: 'Create a new schedule',
  filters: {
    searchPlaceholder: 'Schedule name...'
  },
  table: {
    nameHeader: 'NAME',
    lastEditedHeader: 'LAST EDITED',
    scheduleDetailsHeader: 'SCHEDULE DETAILS',
    activeJrCountHeader: 'ACTIVE JOBS'
  },
  noResults: {
    title: 'You do not have any existing schedules',
    description: 'Schedules are beneficial when you have consistent, planned work. Once created, you can easily assign it to any job.',
  },
  deleteTooltip: 'This schedule is being used by one or more active jobs',
  deleteConfirmation: {
    title: 'Are you sure you want to delete this schedule?',
    description: 'This action cannot be undone.',
    confirm: 'Yes, delete schedule'
  },
  emptyResults: {
    description: 'Try using a different keyword for your search.'
  },
  scheduleDetails: {
    unpaidBreakText: '%minutes% min break'
  },
  form: {
    updateSuccess: 'Schedule updated successfully',
    updateError: 'Failed to update schedule',
    createSuccess: 'Schedule created successfully',
    createError: 'Failed to create schedule'
  }
};
